import script from "./FilterList.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterList.vue?vue&type=script&setup=true&lang=js"

import "./FilterList.vue?vue&type=style&index=0&id=35844724&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35844724"]])

export default __exports__